import script from "./ReturnTo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReturnTo.vue?vue&type=script&setup=true&lang=ts"

import "./ReturnTo.vue?vue&type=style&index=0&id=555f86b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555f86b6"]])

export default __exports__